export default {
  list: [
    { title: 'german', value: 'de', moneyUnit: 'eur' },
    { title: 'english', value: 'en', moneyUnit: 'usd' },
    { title: 'iran', value: 'fa', moneyUnit: 'irr' },
    { title: 'italian', value: 'it', moneyUnit: 'eur' },
    { title: 'russian', value: 'ru', moneyUnit: 'рубль' },
    { title: 'arabic', value: 'ar', moneyUnit: 'aed' },

    // { title: "japanese", value: "ja", moneyUnit: "yen" },
  ],
  values: {
    GERMAN: 'GERMAN',
    ENGLISH: 'ENGLISH',
    PERSIAN: 'PERSIAN',
    ITALIAN: 'ITALIAN',
    RUSSIAN: 'RUSSIAN',
    ARABIC: 'ARABIC',

    // JAPANESE: "JAPANESE",
  },
};
// { title: 'french', value: 'fr', moneyUnit: 'eur' },
// { title: "japanese", value: "ja", moneyUnit: "yen" },
// { title: 'spanish', value: 'es', moneyUnit: 'eur' },

// FRENCH: 'FRENCH',

// JAPANESE: "JAPANESE",
// SPANISH: 'SPANISH'
